export enum BasketTypeOfEntity {
    project = 'project',
    board = 'board',
    column = 'column',
    task = 'task',
    file = 'file'
}